import React from 'react';

// components
import { PrimeButton } from 'components-design-system'

// styles
import './empty-state-checklist.scss';

// assets
import emptyStateIcon from '../../assets/images/empty-state-checklist.png';

const EmptyStateChecklist = ({ onAddChecklist, permissions }) => {
  return (
    <div className="empty-checklist-container">
      <img
        className="empty-checklist-icon"
        src={emptyStateIcon}
        alt="empty-state-checklist" />

      <div className="title-container">
        <h3>Start creating checklists</h3>
        <p>Organize efficiently the files for your transparency needs</p>
      </div>
      {(permissions?.["checklisttemplate.create"] || permissions?.["study.checklist.create"]) && (
        <PrimeButton
          icon={<i className="fal fa-tasks" />}
          onClick={onAddChecklist}
          style={{ marginTop: 40 }}
        >
          Add checklist
        </PrimeButton>
      )}
    </div>
  );
};

export default EmptyStateChecklist;